import { render, staticRenderFns } from "./BlokPermission.vue?vue&type=template&id=0aeb9b28&"
import script from "./BlokPermission.vue?vue&type=script&lang=js&"
export * from "./BlokPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports